import { Component, input } from "@angular/core";
import { NetPaymentReport, NetPaymentReportPagination } from "@shared/models/net-payments.interface";

@Component({
	selector: "app-net-payment-data",
	templateUrl: "./net-payment-data.component.html",
	styleUrls: ["./net-payment-data.component.scss"]
})
export class NetPaymentDataComponent {
	isCPNowDeductionsEnabled = input(false);
	datasource = input<NetPaymentReportPagination>();

	get netPaymentOrders(): NetPaymentReport[] {
		return this.datasource()?.items ?? [];
	}
}
